import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { EventsService } from '../../services/events.service';
import { Warning } from '../../user-input/models/warning';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['../input.component.scss']
})
export class TextInputComponent extends BaseInputComponent implements OnInit {

  @Input() isPreFilledAnswer?: boolean;

  inputMode: string;
  showMaskTyped: boolean;
  isInputDisabled: boolean;
  isAutocapitalized: string;
  keyboardType: string;
  maxLength: number;
  minLength: number;
  disableCopyPaste: boolean;

  showWarning: boolean;
  warningMessage: string;
  warningBorder: boolean;

  constructor(private eventsService: EventsService) {
    super();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent() {
    this.eventsService.valueChanged.emit(true);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.group) {
      this.inputMode = this.group.controls.dataType.value === 'number' ? 'numeric' : 'text';
      this.keyboardType = this.group.controls.keyboardType.value;
      this.disableCopyPaste = this.group.controls.disableCopyPaste?.value;
      if (this.group.controls.warning.value) {
        this.evaluateWarning();
      }
    }
    if (!this.keyboardType) {
      this.keyboardType = 'text';
    }
    if (!this.maxValue) {
      this.maxLength = 255;
    } else {
      this.maxLength = parseInt(this.maxValue, 10);
    }
    if (this.minValue) {
      this.minLength = parseInt(this.minValue, 10);
    }
    this.showMaskTyped = this.mask != null;
    this.isInputDisabled = this.disabled;
    this.setInputFormatType();
    if (this.isPreFilledAnswer === undefined) {
      this.isPreFilledAnswer = this.group && this.group.value.value != null;
    }

    this.group?.valueChanges
      .pipe(debounceTime(600))
      .subscribe(() => {
        this.valueChanged();
      });
  }

  valueChanged() {
    this.evaluateWarning();
    this.change.emit(this.group);
    // this.eventsService.valueChanged.emit(true);
    if (this.isPreFilledAnswer) {
      this.isPreFilledAnswer = false;
    }
  }

  onCopyPaste($event: ClipboardEvent) {
    if (this.disableCopyPaste) {
      $event.preventDefault();
    }
  }

  evaluateWarning() {
    const warning: Warning = this.group.controls.warning.value;

    let showWarning = false;

    if (warning?.condition && (this.group.value.value || warning.condition.evaluateOnInit)) {
      let value1 = warning.condition.value1;
      if (value1 === '@controlValue') {
        value1 = this.group.value.value;
      }

      switch (warning.condition.operator) {
        case 'not equals':
          showWarning = value1.trim().toLowerCase() !== warning.condition.value2.trim().toLowerCase();
          break;
        case 'equals':
          showWarning = value1.trim().toLowerCase() === warning.condition.value2.trim().toLowerCase();
          break;
        default:
        // No warning
      }
    } else if (this.group.controls.value.errors?.invalid || (this.group.controls.value.errors?.required && this.group.touched)) {
      this.showWarning = warning?.message ? true : false;
      this.warningMessage = this.group.controls.value.errors?.required ? warning?.requiredMessage || '' : warning?.message || '';
      this.warningBorder = warning?.warningBorder || false;
    } else {
      this.showWarning = false;
      this.warningMessage = '';
      this.warningBorder = false;
    }

    if (showWarning && (this.group.valid || warning.condition.evaluateOnInit)) {
      this.showWarning = true;
      this.warningMessage = warning.message;
      this.warningBorder = warning.warningBorder;
    }
  }

  setInputFormatType() {
    if (this.formatType === 0) {
      this.isAutocapitalized = 'characters';
      return;
    }
    this.isAutocapitalized = 'none';
  }

  keypress($event) {
    if ($event.currentTarget.value.length > this.maxLength - 1) {
      if ($event.key !== 'Delete' && $event.key !== 'Backspace') {
        $event.target.blur();
      }
    }
    if ($event.key === 'Enter') {
      $event.target.blur();
    }
  }
}
